export const auth0Domain = 'shapevr.us.auth0.com';
export const clientId = '6Y5PKhSLdkBPRvsdtdtaCJ8oTDXCw4S8';